import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ConfirmDialogComponent } from './confirm-dialog.component';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmCaption?: string;
  confirmCaptionIcon?: string;
  confirmCaptionCssStyle?: string;
  messageListCssStyle?: string;
  cancelCaption?: string | boolean;
  downloadReport?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  open(options: ConfirmDialogData): Observable<boolean> {
    const dialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      disableClose: true,
      data: {
        title: options.title,
        message: options.message,
        confirmCaption: options.confirmCaption || $localize`:action:Ok`,
        cancelCaption: options.cancelCaption === undefined ? $localize`:action:Cancel` : options.cancelCaption,
        downloadReport: options.downloadReport,
        confirmCaptionIcon: options.confirmCaptionIcon,
        confirmCaptionCssStyle: options.confirmCaptionCssStyle,
        messageListCssStyle: options.messageListCssStyle,
      },
    });
    return dialogRef.afterClosed().pipe(take(1));
  }

  show(title: string, message: string): void {
    this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
      data: {
        title,
        message,
        confirmCaption: $localize`:action:Ok`,
        cancelCaption: false,
      },
    });
  }
}
